//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class DomainConstants
{
	public static scraperEntityName: string = `Scraper`;
	public static scraperWebPageEntityName: string = `ScraperWebPage`;
	public static scraperWebPageScrapingDataUpdatedDomainEventName: string = `ScraperWebPageScrapingDataUpdatedDomainEvent`;
	public static watchdogEntityName: string = `Watchdog`;
}
